export const SUPPORTED_LANGS = ["ro", "en"];

export function getLangFromPathname(pathname) {
  const parts = String(pathname || "/")
    .split("/")
    .filter(Boolean);
  const first = parts[0];
  return SUPPORTED_LANGS.includes(first) ? first : null;
}

export function stripLangPrefix(pathname) {
  const p = String(pathname || "/");
  const lang = getLangFromPathname(p);
  if (!lang) return p;
  const rest = p.replace(new RegExp(`^/${lang}(?=/|$)`), "");
  return rest || "/";
}

export function withLangPrefix(pathname, lang) {
  const clean = stripLangPrefix(pathname);
  if (!lang || lang === "ro") return clean;
  return clean === "/" ? `/${lang}` : `/${lang}${clean}`;
}

